import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { Box, CircularProgress } from '@mui/material';
import { AuthenticatedApp } from './app/AuthenticatedApp';
import './i18n';
import '@xyflow/react/dist/style.css';
import reportWebVitals from './reportWebVitals';
import store from './store';

const Fallback = () => (
  <Box display="flex" justifyContent="center" sx={{ pt: 16 }}>
    <CircularProgress />
  </Box>
);

const persistor = persistStore(store);

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');
const root = createRoot(container);

root.render(
  <Suspense fallback={<Fallback />}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AuthenticatedApp />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </Suspense>,
);

reportWebVitals();
